import React from 'react';
import { useStateContext } from '../contexts/ContextProvider';

const SearchBox = ({ value, onChange, placeholder = "Search..." }) => {
  const { currentMode } = useStateContext();
  
  return (
    <input
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`border rounded-full px-3 py-2 mr-2 w-full max-w-xs ${
        currentMode === 'Dark' 
          ? 'border-gray-600 bg-secondary-dark-bg-light text-white placeholder-gray-400' 
          : 'border-gray-300 bg-white text-gray-900 placeholder-gray-500'
      }`}
    />
  );
};

export default SearchBox; 